import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';
import { Point } from '../types';

interface Props {
  data: Point[];
}

const PriceHistoryChart: React.FC<Props> = ({ data }) => (
  <ResponsiveContainer width="100%" height={300}>
    <LineChart data={data}>
      <XAxis dataKey="time" />
      <YAxis domain={['auto','auto']} />
      <Tooltip />
      <Line type="monotone" dataKey="value" stroke="#1890ff" dot={false} />
    </LineChart>
  </ResponsiveContainer>
);

export default PriceHistoryChart;
